import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { AppConfig } from '../../../AppConfig';
import { CustomCampaignAdvertiserStyles } from '../../../styles/CustomStyles';
import { SubEntityCardLite } from '../../../components/advertiser/SubEntityCardLite';
import { SubEntityListLite } from '../../../components/advertiser/SubEntityListLite';
import { AppButton } from '../../../common/components/AppButton';
import { Dialog, FormControl, TextField } from '@material-ui/core';
import { Players } from '../../Players';
import ClearIcon from '@material-ui/icons/Clear';
import { Toast } from '../../../components/Toast';
import { campaignDatesFields, campaignFields, campaignGraphicFields, paymentLinkFields } from '../../../data/data';
import Payment from '../../../components/advertiser/stripe/Payment';
import { AppHelper } from '../../../helpers/AppHelper';
import { DisplayPreviewDialog } from '../../../components/DisplayPreviewDialog';
import { ActionDialog } from '../../../common/components/ActionDialog';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { DynamicForm } from '../../../common/components/DynamicForm';
import { Controller } from '../../../common/Controller';
import { AppUiHelper } from '../../../helpers/AppUiHelper';
const queryString = require('query-string');

export class Campaign extends BaseEntityPage {

  constructor(props) {
    super(props, { pageForOrgType: 'ADVERTISER' })
    this.query = queryString.parse(props.location.search);
    this.pageKey = 'Campaign'
    this.pageTitle = Helper.getString('campaignDetails')
    this.orgId = this.props.match.params.orgId
    this.campaignId = this.props.match.params.id
    this.uploadLocation = this.orgId
    if(this.query && this.query.from === 'ss-campaigns' && Controller.get().userMgr().isProductSU()) {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('campaignsSelfServe'), to: '/admin/ss-campaigns' },
        { title: this.pageTitle },
      ]
    } else {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('campaigns'), to: this.baseRoute() + '/campaigns' },
        { title: Helper.getString('campaignDetails') },
      ]
    }
    this.toFetch = [
      { method: 'GET', paths: ['campaigns', this.campaignId], queryParams: { groupId: this.orgId, pb: 'fieldDef' } },
      { method: 'GET', paths: ['orgs', this.orgId] }
    ]
    this.tableHeadersMap = {
      Content: (current) => {
        if (current.iType === 'VIDEO') {
          return AppUiHelper.renderVideoThumbnailCustomStyle(current, {}, { _IMAGEFIT: true, _LARGEIMAGE: true, _IMAGEBORDER: true, _BORDER: true })
        } else {
          return (<div className={css(Styles.imgNameContainer)}>
            <img src={current.content} alt={Helper.getString('adImageAlt')} className={css(Styles.img)} />
          </div>)
        }

      },
      Title: (current) => current.title,
      Info: (current) => {
        if (current.contentWidth && current.contentHeight) {
          return `${current.contentWidth} (w) x ${current.contentHeight} (h)`
        } else {
          ''
        }
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {}
    this.noAdd = true
    this.noTableHead = true
    this.emptyText = Helper.getString('emptyCreatives')
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.message}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  updateCampaign = async (jsonBody) => {
    return await ApiHelper.callAwait({
      method: 'PUT',
      endPoint: ApiHelper.makeUrlPath(['campaigns', this.campaignId]),
      jsonBody,
    })
  }

  buttonAction = async (updateAction) => {
    if (updateAction !== 'generateManualPaymentLink') {
      this.setState({
        inProcess: true,
      })
    } else {
      this.setState({
        showManualPayment: true,
        linkCopied: false
      })
      return
    }
    try {
      const jsonBody = { updateAction }
      const response = await this.updateCampaign(jsonBody)
      if (jsonBody.updateAction === 'startActivateSubscription') {
        const item = this.state.item
        item.state = response.state || item.state
        item.subscriptionStatus = response.subscriptionStatus || item.subscriptionStatus
        this.setState({
          showPaymentDialog: true,
          paymentInfo: {
            subscriptionId: response.subscriptionId,
            clientSecret: response.clientSecret,
            pubKey: response.pubKey || 'pk_test_up2LcQj8XUuT2cFbcw5lIzMZ',
            orgId: this.orgId,
            campaignId: this.campaignId
          },
          item,
          inProcess: false
        })
      } else {
        this.fetchItems()
      }
    } catch (err) {
      this.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error'
      })
    }
  }

  buttonActionOld = async () => {
    this.setState({
      inProcess: true
    })
    const { action } = this.getButtonTitleAndAction()
    const jsonBody = {}
    if (action === 'startActivateSubscription') {
      jsonBody.updateAction = 'startActivateSubscription'
    } else if (action === 'submitForReview') {
      jsonBody.updateAction = 'submitForReview'
    } else if (action === 'enable') {
      jsonBody.updateAction = 'enable'
    } else if (action === 'disable') {
      jsonBody.updateAction = 'disable'
    }
    try {
      const response = await ApiHelper.callAwait({
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['campaigns', this.campaignId]),
        jsonBody,
      })
      if (jsonBody.updateAction === 'startActivateSubscription') {
        const item = this.state.item
        item.state = response.state || item.state
        item.subscriptionStatus = response.subscriptionStatus || item.subscriptionStatus
        this.setState({
          showPaymentDialog: true,
          paymentInfo: {
            subscriptionId: response.subscriptionId,
            clientSecret: response.clientSecret,
            pubKey: response.pubKey || 'pk_test_up2LcQj8XUuT2cFbcw5lIzMZ',
            orgId: this.orgId,
            campaignId: this.campaignId
          },
          item,
          inProcess: false
        })
      } else {
        this.fetchItems()
      }
    } catch (err) {
      this.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error'
      })
    }
  }

  onFetchSuccess(results) {
    const result = results[0]
    const org = results[1]
    this.formDefinitionCampaignGraphics = campaignGraphicFields.fieldDef
    this.formDefinitionCampaignDates = campaignDatesFields.fieldDef
    this.campaignFields = campaignFields.fieldDef
    if (org.reseller === 'YES') {
      const existingEndTsField = this.campaignFields.steps[0].fields.find(
        (field) => field.key === 'endTs'
      );
      if (!existingEndTsField) {
        this.campaignFields.steps[0].fields.push({
          key: 'endTs',
          type: 'date',
          label: 'End date',
          hint: 'Provide end date',
          value: result.endTs,
          // eslint-disable-next-line camelcase
          v_required: { value: false, message: 'provide end date' }
        });
      }
    }
    const infoItems = [
      {
        key: 'locationName',
        title: 'Location',
        displayValue: (result.query && result.query.radius) + ' miles within ' + (result.query && result.query.location && result.query.location.name),
        image: require('../../../assets/images/location.svg')
      },
      {
        key: 'screens',
        title: 'Selected Screens',
        displayValue: (result.screens && result.screens.length || 0) + ' screen(s)',
        image: require('../../../assets/images/monitor.svg')
      },
      {
        key: 'frequency',
        title: 'Ad Frequency',
        displayValue: result && result.frequency,
        image: require('../../../assets/images/document.svg')
      },
      {
        key: 'startTs',
        title: 'Start date',
        displayValue: result.startTs && AppHelper.formatCampaignTs(result.startTs),
        startTs: result.startTs,
        image: require('../../../assets/images/calendar.svg'),
        datePresent: Boolean(result.startTs)
      }
    ]
    // Conditionally push endTs if reseller is 'YES'
    if (org.reseller === 'YES') {
      infoItems.push({
        key: 'endTs',
        title: 'End date',
        displayValue: result.startTs && AppHelper.formatCampaignTs(result.endTs),
        endTs: result.endTs,
        image: require('../../../assets/images/calendar.svg'),
        datePresent: Boolean(result.endTs)
      });
    }
    this.setState({
      // dateItems: [
      //   {
      //     key: 'startTs',
      //     title: 'Start date',
      //     displayValue: result.startTs && AppHelper.formatCampaignTs(result.startTs),
      //     startTs: result.startTs,
      //     image: require('../../../assets/images/calendar.svg'),
      //     datePresent: Boolean(result.startTs)
      //   },
      //   {
      //     key: 'endTs',
      //     title: 'End date',
      //     displayValue: result.endTs && AppHelper.formatCampaignTs(result.endTs),
      //     endTs: result.endTs,
      //     image: require('../../../assets/images/calendar.svg'),
      //     datePresent: Boolean(result.endTs)
      //   },
      // ],
      infoItems: infoItems,
      adImageItems: Helper.sortAscending(Helper.dictToArray(result.items)),
      item: result,
      inProcess: false,
      message: '',
      showToast: false,
      severity: '',
      preview: false,
      current: null,
      showActionDialog: false,
      org
    })
    this.pageTitle = result.title
  }

  onEdit() {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', this.campaignId]),
      apiData: {},
    });
  }

  openModalForSE(options) {
    const { current, entityAttrName, entityAction } = options

    if (entityAttrName === 'items') {
      this.formDefinition = {
        title: this.formDefinitionCampaignGraphics.title,
        steps: [{ fields: [] }]
      }
      for (const f of this.formDefinitionCampaignGraphics.steps[0].fields) {
        const field = {}
        for (const key in f) {
          field[key] = f[key]
        }
        this.formDefinition.steps[0].fields.push(field)
      }
    }
    this.formDefinition.formType = entityAction
    if (entityAction === 'edit') {
      this.formDefinition.steps[0].fields.forEach(item => {
        if (item.key === 'contentName') {
          item.hide = true;
        }
      });
      this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    } else {
      this.formDefinition.steps[0].fields.forEach(item => {
        if (item.key === 'contentName') {
          item.hide = false;
        }
      });
      this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = false
    }
    if (entityAction === 'add') {
      this.formDefinition.steps[0].fields.find(i => i.key === 'order').hide = true
      this.formDefinition.steps[0].fields.find(i => i.key === 'order').defaultValue = String(this.state.adImageItems && this.state.adImageItems.length + 1)
    } else {
      this.formDefinition.steps[0].fields.find(i => i.key === 'order').hide = false
    }

    if (current) {
      Helper.populateFormDefinitionValues(this.formDefinition, current)
    }

    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction, entityAttrName, id: current ? current.id : undefined },
      apiEndPoint: ApiHelper.makeUrlPath(['campaigns', this.campaignId]),
      modalOpen: true
    })
  }

  getButtonTitleAndAction = () => {
    if (!this.state.item) return {}
    const mpItem = this.getMpItem()
    if (this.state.item.subscriptionStatus !== 'ACTIVE' && this.state.item.manualPaymentStatus !== 'PAID') {
      if (this.state.org.reseller === 'YES') {
        return {
          btnTitle: mpItem.orderId ? Helper.getString('viewPaymentLink') : Helper.getString('getPaymentLink'),
          action: 'generateManualPaymentLink'
        }
      } else {
        return {
          btnTitle: Helper.getString('makePayment'),
          action: 'startActivateSubscription'
        }
      }
    } else if ((this.state.item.subscriptionStatus === 'ACTIVE' || this.state.item.manualPaymentStatus === 'PAID') && !this.state.item.reviewStatus || this.state.item.reviewStatus === 'INIT') {
      return {
        btnTitle: Helper.getString('submitReview'),
        action: 'submitForReview'
      }
    } else if (this.state.item.state === 'LIVE') {
      return {
        btnTitle: Helper.getString('disableCampaign'),
        action: 'disable'
      }
    } else if (this.state.item.state === 'DISABLED') {
      return {
        btnTitle: Helper.getString('enableCampaign'),
        action: 'enable'
      }
    } else {
      return {}
    }
  }

  paymentDialog = () => {
    return (
      <Dialog
        fullScreen={window.innerWidth < 767 ? true : false}
        open={this.state.showPaymentDialog || false}
        onClose={() => this.setState({ showPaymentDialog: false })}
        classes={{
          root: css(Styles.customRoot),
          paperWidthSm: css(Styles.customPaper),
        }}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <p className={css(Styles.modalTitle)}>Subscription Payment</p>
          <button className={css(Styles.modalCloseButton)} onClick={() => this.setState({ showPaymentDialog: false })} disabled={this.state.inProcess}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <Payment {...this.state.paymentInfo} />
        </div>
      </Dialog>
    )
  }

  renderCampaignEditDailog = () => {
    return (
      <Dialog open={this.state.editCampaignModal} onClose={() => this.setState({ editCampaignModal: false })}
        classes={{
          root: css(Styles.root),
          paperWidthSm: css(Styles.paper),
        }}>
        <div className={css(Styles.closeContainer)} onClick={() => this.setState({ editCampaignModal: false })}><ClearIcon /></div>
        <Players edit closeModal={() => this.setState({ editCampaignModal: false })} data={this.state} />
      </Dialog>
    )
  }

  creativePreivewDialog = () => {
    if (!this.state.preview) return ''
    return (
      <DisplayPreviewDialog
        title={this.state.current.title}
        isOpen={this.state.preview ? true : false}
        adLink={this.state.current.content}
        onClosed={() => this.setState({ preview: false })}
      />
    )
  }

  openModalForPreview = (options) => {
    const { current } = options
    this.setState({
      current,
      preview: true
    })
  }

  onCancelCampaign = async () => {
    return await this.updateCampaign({ updateAction: 'cancel' })
  }

  renderActionDialog = () => {
    if (!this.state.showActionDialog) return ''
    return (
      <ActionDialog
        doAction={this.onCancelCampaign}
        onSuccessCallback={() => this.fetchItems()}
        isOpen={this.state.showActionDialog}
        title={Helper.getString('cancelCampaign')}
        onClose={() => this.setState({ showActionDialog: false })}
        buttonText={Helper.getString('cancelCampaignConfirmationButton')}
      >
        <p className={css(Styles.cancelInfo)}>{Helper.getString('cancelCampaignMessage')}</p>
      </ActionDialog>
    )
  }

  isCancelled = () => {
    return this.state.item.state === 'CANCELLED'
  }

  isSubscriptionStatusActive = () => {
    return this.state.item && this.state.item.subscriptionStatus === 'ACTIVE'
  }

  onCopy() {
    if (!navigator.clipboard) return
    const link = this.constructPaymentLink()
    navigator.clipboard.writeText(link).then(() => {
      this.setState({
        linkCopied: true
      })
    });
  }

  constructPaymentLink() {
    const mpItem = this.getMpItem()
    return AppConfig.DASHBOARD_WEB_LINK + '/campaign-pgm?order_id=' + mpItem.orderId
  }

  handleCustomSubmit(options, callback) {
    const { formData, caller } = options
    ApiHelper.call({
      method: 'PUT',
      endPoint: ApiHelper.makeUrlPath(['campaigns', this.campaignId]),
      jsonBody: {
        amount: formData.amount,
        durationMonths: formData.durationMonths,
        updateAction: 'generateManualPaymentLink'
      }
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      } else {
        caller.setState({
          success: true,
          message: '',
          inProcess: false
        })
        this.setState({
          manualPayment: result.manualPayment
        })
      }
    })
  }

  getMpItem() {
    return this.state.item.manualPayment  || this.state.manualPayment || {}
  }

  renderManualPayment = () => {
    const mpItem = this.getMpItem()
    const title =  mpItem.orderId ? 'Payment Link' : 'Generate Payment Link'
    return (
      <Dialog
        open={this.state.showManualPayment}
        onClose={() => this.setState({ showManualPayment: false, linkCopied: false })}
        fullWidth={true}
        classes={{
          root: css(Styles.customRoot),
          paperWidthSm: css(Styles.paymentUrlDialogcustomPaper),
        }}>
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{title}</div>
          <button className={css(Styles.modalCloseButton)}
            onClick={() => this.setState({ showManualPayment: false, linkCopied: false })} disabled={this.state.inProcess}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.dialogContent)}>
          {!(mpItem.orderId) && (
            <DynamicForm
              formDefinition={paymentLinkFields.fieldDef}
              customSubmit={this.handleCustomSubmit.bind(this)} />
          )}

          {mpItem.orderId && (
            <div className={css(Styles.generatedLinkContainer)}>
              <span className={css(Styles.amount)}><strong>Amount:</strong>  ${mpItem.amount / 100}</span>
              <div className={css(Styles.paymentLnkContainer)} onClick={() => this.onCopy()}>
                <span className={css(Styles.paymentLink)}>{this.constructPaymentLink()}</span>
                <i className='material-icons-outlined' style={{ fontSize: 20, color: '#222222' }}>content_copy</i>
              </div>
              {this.state.linkCopied && <span style={{textAlign: 'center', fontWeight: 'bold'}}>Copied</span>}
            </div>
          )}
        </div>
      </Dialog>
    )
  }

  isPaymentDone() {
    if(this.state.item && this.state.item.subscriptionStatus === 'ACTIVE' && this.state.org.reseller !== 'YES') {
      return true
    }
    if(this.state.item && this.state.item.manualPaymentStatus === 'PAID' && this.state.org.reseller === 'YES') {
      return true
    }
    return false
  }

  shouldEnableMediaActions() {
    // return (this.isCancelled() || !this.isPaymentDone()) && !Controller.get().userMgr().isProductSU()
    return (this.isCancelled() || !this.isPaymentDone())
  }

  renderTable() {
    const { btnTitle } = this.getButtonTitleAndAction()
    return (
      <Fragment>
        <div className={css(Styles.pageContainer)}>
          {!this.isCancelled() &&
            <div className={css(Styles.paymentContainer)}>
              <div className={css(Styles.priceContainer)}>
                {AppHelper.renderCampaignCost(this.state.item.price,
                  this.state.item.screens && this.state.item.screens.length,
                  { org: this.state.org, manualPayment: this.state.item.manualPayment || {}})
                }
              </div>
              {btnTitle &&
                <AppButton
                  onClick={() => {
                    const { action } = this.getButtonTitleAndAction()
                    this.buttonAction(action)
                  }}
                  buttonText={btnTitle}
                  buttonTextStyle={Styles.buttonTextStyle}
                  inProcess={this.state.inProcess}
                  buttonStyle={Styles.actionButton}
                />
              }
              {(this.isPaymentDone() || this.state.org.reseller === 'YES') &&
                <AppButton
                  onClick={() => this.setState({ showActionDialog: true })}
                  buttonText={Helper.getString('cancelCampaign')}
                  buttonTextStyle={[Styles.buttonTextStyle, Styles.cancelButtonTextStyle]}
                  buttonStyle={[Styles.actionButton, Styles.cancelButton]}
                />
              }
            </div>
          }
          <SubEntityCardLite
            isGrid
            org={this.state.org}
            items={this.state.infoItems}
            item={this.state.item}
            openModalForEdit={this.isCancelled() ? null : () => {
              this.openModalForEdit({ title: this.pageTitle, startTs: this.state.item.startTs, endTs: this.state.item.endTs }, this.campaignFields)
            }}
          />

          <SubEntityListLite
            tableHeadersMap={this.tableHeadersMap}
            noTableHead={true}
            items={this.state.adImageItems || []}
            title={Helper.getString('creatives')}
            buttonTitle='Upload'
            emptyText={Helper.getString('emptyCreatives')}
            noDelete={this.shouldEnableMediaActions()}
            noEdit={this.shouldEnableMediaActions()}
            noPreview={this.shouldEnableMediaActions()}
            noAdd={this.shouldEnableMediaActions()}
            openModalForEdit={(current) => this.openModalForSE({ current, entityAttrName: 'items', entityAction: 'edit' })}
            openModalForDelete={(current) => this.openModalForSE({ current, entityAttrName: 'items', entityAction: 'del' })}
            openModalForAdd={(current) => this.openModalForSE({ current, entityAttrName: 'items', entityAction: 'add' })}
            openModalForPreview={(current) => this.openModalForPreview({ current })}
          />
        </div>

        {/* {this.renderCampaignEditDailog()} */}
        {this.paymentDialog()}
        {this.getToast()}
        {this.creativePreivewDialog()}
        {this.renderActionDialog()}
        {this.renderManualPayment()}
      </Fragment>
    )
  }
}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('CampaignAdvertiser')) ? CustomCampaignAdvertiserStyles : StyleSheet.create({
  img: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    borderRadius: 10,
    overflow: 'hidden',
    border: '1px solid #d3d3d3'
  },
  pageContainer: {
    display: 'flex',
    flex: 1,
    gap: 20,
    flexDirection: 'column',
    paddingBottom: 40,
    '@media (max-width: 767px)': {
      marginLeft: 10,
      marginRight: 10,
    }
  },
  buttonStyle: {
    background: 'transparent',
    border: '1px solid ' + AppConfig.TINT_COLOUR,
    borderRadius: 8,
  },
  imgNameContainer: {
    height: 75,
    width: 75
  },
  imgName: {
    color: '#3FA5D6'
  },
  paymentContainer: {
    padding: 0,
    borderRadius: 16,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
    gap: 20,
    flex: 1,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'flex-end',
    }
  },
  mobTableGraphicDetail: {
    display: 'flex',
    flexDirection: 'column'
  },
  paper: {
    maxWidth: 'unset',
    minWidth: '75dvw',
    zIndex: 11,
    width: '100%',
    height: '90dvh',
    '@media (max-width: 767px)': {
      minWidth: '90dvw'
    },
    borderRadius: 40
  },
  closeContainer: {
    marginBottom: 10,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '20px 40px 0px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    position: 'absolute'
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600,
    margin: 0
  },
  modalCloseButton: {
    position: 'absolute',
    top: 33,
    right: 30,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 18,
    height: 18
  },
  modalHeader: {
    padding: 25,
    paddingBottom: 20
  },
  customRoot: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    zIndex: 13000
  },
  customPaper: {
    borderRadius: 40,
    minWidth: 500,
    minHeight: 500,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 767px)': {
      borderRadius: 0,
      minWidth: 'unset',
    },
  },
  modalContent: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  title: {
    fontSize: 26,
    margin: 0
  },
  buttonTextStyle: {
    fontSize: 16,
    fontWeight: 700,
    margin: 0,
    color: '#FFFFFF',
    '@media (max-width: 767px)': {
      fontSize: 16,
    }
  },
  actionButton: {
    minWidth: 155
  },
  cancelInfo: {
    margin: 0,
    color: '#D10000'
  },
  cancelButton: {
    backgroundColor: '#FFFFFF'
  },
  cancelButtonTextStyle: {
    color: AppConfig.TINT_COLOUR
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  dialogContent: {
    padding: 20,
    paddingTop: 0,
    paddingLeft: 25,
    paddingRight: 25,
    textAlign: 'center'
  },
  dialogTitle: {
    marginBottom: 20
  },
  inputStyle: {
    padding: 10,
    width: '80%',
    marginBottom: 15
  },
  generatedLink: {
    marginTop: 20
  },
  price: {
    fontSize: 24,
    fontWeight: 600,
    color: '#1B1B1B',
    margin: 0
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/Campaign.js